export default {
	setFeatureFlags: ({ commit }) => {
		axios.get('/api/feature-flags').then(
			({
				data: {
					data: { feature_flags },
				},
			}) => {
				commit('SetFeatureFlags', feature_flags)
			}
		)
	},
	setFeatureFlag: ({ commit, state }, flag) => {
		if (!state.featureFlags.some(feature => feature.tag === flag)) {
			axios.get(`/api/feature-flags/${flag}`).then(
				({
					data: {
						data: { feature_flag },
					},
				}) => {
					commit('SetFeatureFlag', feature_flag)
				}
			)
		}
	},
}
